import * as React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { getOrgUsers, setUserCurrentPage } from '~/apps/shared/actions/users';
import UserListTable from '~/apps/pos/admin/components/users/UserListTable';
import { createRouteNodeSelector } from 'redux-router5';
import { getUserOrgFilter } from '~/apps/shared/services/qsfilter';
import { defaultTablePageSize } from '~/common/components/consts';

class OrgUserListTable extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      deleteConfirm: false,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        this.onFetchData({page: 0, pageSize: defaultTablePageSize}, null);
      }
    }
  };
  onFetchData = (state, instance) => {
    const { orgId, dispatch, filter } = this.props;

    dispatch(getOrgUsers(filter, state.page * state.pageSize));
  };

  onEdit = (model) => {
    this.props.onEdit(model.id);
  };

  onDelete = (model) => {
    this.props.onDelete(model.id);
  };

  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setUserCurrentPage(page));
  };

  render() {
    const { users, auth: {currentUser} } = this.props;
    const _users = !users.ui || !users.ui.currentList ? [] : users.ui.currentList.map(u => users.entities[u]);

    return (
      <UserListTable
        manual={true}
        loading={users.ui.loading}
        page={users.ui.currentPage}
        currentUserRole={currentUser.role}
        currentUserLocationId={currentUser.locationId}
        data={_users}
        onFetchData={this.onFetchData}
        onEdit={this.onEdit}
        onDelete={this.onDelete}
        onPageChange={this.onPageChange}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos.admin.settings.team');
  const { route: { params } } = selector(state);
  const filter = getUserOrgFilter(params);

  return {
    auth: state.shared.auth,
    users: state.shared.users,
    filter,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgUserListTable);
